<template>
  <div class="restriktionen-kalendertag">
    <div
      v-for="(entry, index) in entries"
      :key="index"
      class="restriktionen-kalendertag__group"
      :style="{ borderLeftColor: typeConfig(entry.type).borderColor }"
    >
      <div v-if="entry.laender && entry.laender.length" class="restriktionen-kalendertag__row">
        <span class="restriktionen-kalendertag__chip restriktionen-kalendertag__chip--neutral">
          <Globe :size="14" />
        </span>
        <div class="restriktionen-kalendertag__text">
          <span class="restriktionen-kalendertag__label">
            {{ entry.laender.length > 1 ? 'LÄNDER' : 'LAND' }}
          </span>
          <span class="restriktionen-kalendertag__value">{{ entry.laender.join(', ') }}</span>
        </div>
      </div>

      <div v-if="entry.reisekuerzel && entry.reisekuerzel.length" class="restriktionen-kalendertag__row">
        <span class="restriktionen-kalendertag__chip restriktionen-kalendertag__chip--neutral">
          <Plane :size="14" />
        </span>
        <div class="restriktionen-kalendertag__text">
          <span class="restriktionen-kalendertag__label">
            {{ entry.reisekuerzel.length > 1 ? 'REISEN' : 'REISE' }}
          </span>
          <span class="restriktionen-kalendertag__value">{{ entry.reisekuerzel.join(', ') }}</span>
        </div>
      </div>

      <div class="restriktionen-kalendertag__row">
        <span
          class="restriktionen-kalendertag__chip"
          :style="{
            backgroundColor: typeConfig(entry.type).bgColor,
            color: typeConfig(entry.type).textColor,
          }"
        >
          <CircleAlert :size="14" />
        </span>
        <div class="restriktionen-kalendertag__text">
          <span class="restriktionen-kalendertag__label">GRUND</span>
          <span class="restriktionen-kalendertag__value">{{ entry.grund }}</span>
        </div>
      </div>

      <div v-if="entry.kommentar" class="restriktionen-kalendertag__row">
        <span class="restriktionen-kalendertag__chip restriktionen-kalendertag__chip--neutral">
          <MessagesSquare :size="14" />
        </span>
        <div class="restriktionen-kalendertag__text">
          <span class="restriktionen-kalendertag__label">KOMMENTARE</span>
          <span class="restriktionen-kalendertag__value restriktionen-kalendertag__value--muted">
            {{ entry.kommentar }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CircleAlert, MessagesSquare, Plane, Globe } from 'lucide-vue';
import restriktionenTypMixin from './restriktionen-typ.mixin.js';

export default {
  name: 'RestriktionenKalendertagHoverComponent',
  mixins: [restriktionenTypMixin],
  components: {
    CircleAlert,
    MessagesSquare,
    Plane,
    Globe,
  },
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.restriktionen-kalendertag {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.restriktionen-kalendertag__group {
  padding: 8px;
  border: 1px solid var(--border);
  border-left: 4px solid;
  border-radius: var(--radius-sm);
}

.restriktionen-kalendertag__row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.restriktionen-kalendertag__row + .restriktionen-kalendertag__row {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

.restriktionen-kalendertag__chip {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
}

.restriktionen-kalendertag__chip--neutral {
  background-color: #b5b5c326;

  color: var(--text-body);
}

.restriktionen-kalendertag__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 4px;
}

.restriktionen-kalendertag__label {
  font-size: 10px;
  line-height: 12px;
  font-weight: 600;
  color: var(--text-muted);
}

.restriktionen-kalendertag__value {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: var(--text);
}

.restriktionen-kalendertag__value--muted {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--text-body);
}
</style>
